<template>
  <div class="slideshow-wrap">
    <slick
      ref="newsSlick"
      class="news-slider"
      @beforeChange="onChange"
      :options="newsOptions"
    >
      <article v-for="(item, key) in news" v-bind:key="key">
        <p class="date">{{item.published_at}}</p>
        <h3><a :href="item.url" class="title">{{item.title}}</a></h3>
        <p class="description">
         {{item.summary}}
        </p>
        <a :href="item.url" class="action flex align-center">
          Read More
          <img src="/images/icons/right-main.svg" alt="" />
        </a>
      </article>
    </slick>

    <div class="slide-controller" v-if="news.length > 1">
      <img
        :class="{ active: currentSlide > 0 }"
        src="/images/icons/next_arrow-blue.svg"
        alt=""
        @click="prev()"
      />
      <div class="pages">
        <span
          v-for="(slide, i) in news.length"
          :key="i"
          :class="{ active: currentSlide === i }"
          @click="goToSlide(i)"
        ></span>
      </div>
      <img
        :class="{ active: currentSlide < news.length }"
        src="/images/icons/next_arrow-blue.svg"
        alt=""
        @click="next()"
      />
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick";
export default {
  props: {
      news: Array
  },
  components: {
    slick: VueSlickCarousel,
  },
  data() {
    return {
      currentSlide: 0,
      newsOptions: {
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        infinite: true,
        centerMode: false,
        autoplay: false,
        responsive: [
          {
            breakpoint: 1224,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 0,
              centerMode: false,
            }
          },
          {
            breakpoint: 1020,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              centerMode: false,
            }
          }
        ]
      }
    };
  },
  methods: {
    next() {
      if (this.currentSlide < this.news.length) {
        this.$refs.newsSlick.next();
      }
    },
    prev() {
      if (this.currentSlide > 0) {
        this.$refs.newsSlick.prev();
      }
    },
    onChange(event, slick, currentSlide, nextSlide) {
      this.currentSlide = nextSlide;
    },
    goToSlide(i) {
      this.$refs.newsSlick.goTo(i);
    },
  },
};
</script>


<style scoped lang="scss">
.slide-controller {
  position: absolute;
  bottom: -59px;
  right: 0;
  left: 0;
  margin: 0 auto;

  display: flex;
  justify-content: space-between;
  align-items: center;

  width: fit-content;

  @media (min-width: 724px) {
    bottom: -59px;
    right: 12px;
    left: unset;

    margin: unset;
  }
  @media (min-width: 1224px) {
    right: calc(12% + 264px);
    bottom: -80px;
  }

  img {
    cursor: pointer;
    opacity: 0.25;

    transition: all 0.3s ease;

    &.active {
      opacity: 1;
    }

    &:first-child {
      transform: rotate(180deg);

      margin-right: 6px;
    }

    &:last-child {
      margin-left: 6px;
    }

    &.active {
      opacity: 1;
    }
  }

  .pages {
    display: flex;

    @media (max-width: 724px) {
      max-width: 240px;
    }

    span {
      height: 2px;
      width: 28px;

      background-color: #005490;

      opacity: 0.2;

      transition: all 0.3s ease-in-out;
      cursor: pointer;

      margin: 0 2px;

      &.active {
        opacity: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/sliders/NewsSlider.vue